import { app } from "@/main.js"

const defaultState = () => {
	return {
		accessType: null,
		accessToken: null,
		isAuthenticated: false,
		tokenExpiry: null,
		jwtPayload: null,
		isSuperAdmin: false,
		isOrganisationAdmin: false,
		isAuditAdmin: false,
		isGeneralUser: false,
		hasOrg: false,
		token: null,
		isTokenExpired: false,
		organisationsList: null,
		currentOrganisation: {},
		currentUser: null,
		usersWithVertexRoles : null,
	}
}

const state = () => ({
	accessType: null,
	accessToken: null,
	isAuthenticated: false,
	tokenExpiry: null,
	jwtPayload: null,
	isSuperAdmin: false,
	isOrganisationAdmin: false,
	isAuditAdmin: false,
	isGeneralUser: false,
	hasOrg: false,
	token: null,
	isTokenExpired: false,
	redirectLink: null,
	organisationsList: null,
	currentOrganisation: {},
	currentUser: null,
	usersWithVertexRoles : null,
});

const getters = {}

const actions = {
	resetState({ commit }) {
		commit("resetState")
	},

	logout({ commit, state }) {
		
		let logoutUrl = `${app.config.globalProperties.$config.getLoginLink()}&logout=true`

		if (!state.isSuperAdmin && (state.accessType == null && (!state.isOrganisationAdmin && !state.isAuditAdmin && !state.isGeneralUser))) {
			logoutUrl = `${logoutUrl}&message=Unauthorized access. Please contact administrator.`;
		}

		if (state.isTokenExpired) {
			logoutUrl = `${logoutUrl}&error=TOKEN_EXPIRE`
		}

		if (!state.isAuthenticated) {
			logoutUrl = `${app.config.globalProperties.$config.getLoginLink()}&logout=true`;
		}

		if (state.redirectLink != null) {
			logoutUrl = `${logoutUrl}&redirectTo=${app.config.globalProperties.$config.getServerHost()}${state.redirectLink}`;
		}
		
		commit("resetState");

		window.location.href = logoutUrl
	},
};

const mutations = {
	resetState(state) {
		Object.assign(state, defaultState());
	},

	setAccessToken(state, accessToken) {
		state.accessToken = accessToken;
	},

	setJwtPayload(state, payload) {
		state.jwtPayload = payload;
		state.tokenExpiry = payload.expires_at;

		if (payload && payload.roles) {
			
			state.isSuperAdmin = payload.roles.includes("super_admin");
			
			// for vertex roles
			if (!state.isSuperAdmin) {
				if (payload.roles.includes("consultant_admin")) {
					state.accessType = 'consultant_admin'
				// } else if (payload.roles.includes("consultant")) {
				// 	state.accessType = 'consultant'
				} else {
					state.accessType = null
				}
			}

		}

		if (payload.organisation_role != null) {
			state.hasOrg = true

			if (payload.organisation_role[0].products != null) {
				payload.organisation_role[0].products.forEach((p) => {
					
					if (p.product == "audit") {

						state.isOrganisationAdmin = payload.organisation_role[0].is_organisation_admin

						if (state.accessType == null && !state.isOrganisationAdmin) {
							if (p.roles.includes("admin")) {
								state.isAuditAdmin = p.roles.includes("admin")
							} else if (p.roles.includes("general_user")) {
								state.isGeneralUser = p.roles.includes("general_user")
							}
						} 
					}
						
				})
			}

		}

		state.currentUser = {
			id: payload.user_id,
			uuid: payload.user_uuid,
			first_name: payload.first_name,
			last_name: payload.last_name,
			organisation: {
				id: payload.organisation_role != null ? payload.organisation_role[0].organisation_id : 0,
				orguuid: payload.organisation_uuid,
				name: payload.organisation_role != null ? payload.organisation_role[0].organisation : "",
			}
		}
		
	},

	authenticated(state, authenticated) {
		state.isAuthenticated = authenticated;
	},

	setIsTokenExpired(state) {
		state.isTokenExpired = true;
	},

	setRedirectLink(state, link) {
		state.redirectLink = link
	},

	setOrganisationsList(state, orgs) {
		state.organisationsList = orgs
	},

	setCurrentOrganisation(state, org) {
		state.currentOrganisation = org
	},

	setCurrentUser(state, user) {
		state.currentUser = user
	},

	setUsersWithVertexRoles(state, users) {
		state.usersWithVertexRoles = users
	},
};

export default {
	name: "auth",
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
